module.exports = __webpack_public_path__ + "like-f510f94def887c1c8e3e.png";